import { TooltipHost } from '@h2oai/ui-kit';
import React from 'react';

import { formatDefaultDateAndTimeWithSeconds, formatDefaultDateOnly } from '../../utils/utils';

export type DateShortProps = {
  date: string | number; // expects an ISO-8601 date string or a timestamp
};

export const DateShort = React.memo(function DateShort(props: DateShortProps) {
  const date = new Date(props.date);
  return (
    <TooltipHost content={formatDefaultDateAndTimeWithSeconds(date)}>
      <time dateTime={date.toISOString()} tabIndex={-1}>
        {formatDefaultDateOnly(date)}
      </time>
    </TooltipHost>
  );
});
